<template>
    <el-form :model="formData" :rules="rules" ref="stepForm">
        <el-row :gutter="15">
            <el-col :span="24" class="form-step-title">
                <div class="steptitle">
                    {{ stepTitle }}
                </div>
                <el-checkbox v-if="formData['sameAsApplicant']!==undefined" v-model="formData['sameAsApplicant']">Same
                    as applicant details
                </el-checkbox>
                <div v-else>&nbsp;</div>
            </el-col>
            <el-col :sm="24" :md="12" v-for="(val,field,i) in value" :key="'validation'+i">
                <el-form-item :prop="field" v-if="field=='applying_as'">
                    <label class="el-form--label-top">{{ __('fieldnames.' + field) }}* </label>
                    <div style="width:100%">
                        <el-radio v-model="formData[field]" label="designer">Designer</el-radio>
                        <el-radio v-model="formData[field]" label="manufacturer">Manufacturer</el-radio>
                        <el-radio v-model="formData[field]" label="pr_agency">PR Agency</el-radio>
                        <el-radio v-model="formData[field]" label="other">Other</el-radio>
                    </div>
                </el-form-item>
                <div v-else-if="field=='sameAsApplicant'"></div>
                <el-form-item :prop="field" v-else-if="field=='newsletter'">
                    <label class="el-form--label-top">{{ __('fieldnames.' + field) }}* </label>
                    <div style="width:100%">
                        <el-radio v-model="formData[field]" :label="1">Yes</el-radio>
                        <el-radio v-model="formData[field]" :label="0">No</el-radio>
                    </div>
                </el-form-item>
                <el-form-item :prop="field" v-else-if="field=='country'">
                    <InputWh :placeholder="field" :options="countryOptions" fieldType="select"
                             :required="rules[field][0].required" :disabled="isSame" :formName="formName"
                             :formStep="step"
                             v-model="formData[field]" @change="formData.state_region=''"></InputWh>
                </el-form-item>
                <template v-else-if="field=='state_region'">
                    <el-form-item :prop="field" v-if="currentStateOptions!={} && currentStateOptions.length!=0">
                        <InputWh :placeholder="field" :options="currentStateOptions" fieldType="select"
                                 :required="rules[field][0].required" :disabled="isSame" :formName="formName"
                                 :formStep="step"
                                 v-model="formData[field]"></InputWh>
                    </el-form-item>
                    <div class="emptyfield" v-else>&nbsp;</div>
                </template>
                <el-form-item :prop="field" v-else-if="field=='category'">
                    <InputWh :placeholder="field" :options="categoryOptions" fieldType="select"
                             :required="rules[field][0].required" :formName="formName" :formStep="step"
                             v-model="formData[field]" @change="formData.subcategory=''"></InputWh>
                </el-form-item>
                <template v-else-if="field=='subcategory'">
                    <el-form-item :prop="field">
                        <InputWh :placeholder="field" :options="subCategoryOptions[formData.category]"
                                 fieldType="select" :formName="formName" :formStep="step"
                                 :required="rules[field][0].required"
                                 v-model="formData[field]"></InputWh>
                    </el-form-item>
                </template>
                <el-form-item :prop="field" v-else-if="field=='year_of_production'">
                    <InputWh :placeholder="field" :options="yearOptions" fieldType="select"
                             :required="rules[field][0].required" :formName="formName" :formStep="step"
                             v-model="formData[field]"></InputWh>
                </el-form-item>
                <template v-else-if="field=='images'">
                    <el-form-item :prop="field">
                        <div class="field-heading">Image Upload *</div>
                        <div class="upload-pretext">
                            FILE TYPE: JPG, PNG. ASPECT RATIO: W:1920px H:1080px. 300dpi/image, max 6MB per file. The
                            file names should use explicitly Latin characters.
                        </div>
                        <el-upload
                            ref="uploader"
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :multiple="true"
                            :drag="true"
                            :on-change="handleChange"
                            :on-remove="handleRemove"
                            :file-list="formData.images"
                            :auto-upload="false"
                            list-type="picture">
                            <div class="el-upload__text">
                                Drop files or click here to upload <em>up to 6 images</em>
                                <div class="upload-icon"></div>
                            </div>
                        </el-upload>
                        <div class="upload-aftertext">
                            Notice: For more images or 3d renderings and plans please forward directly to us using
                            either through wetransfer or dropbox along with a fully completed postal application at
                            contact@globaldesignnews.com
                        </div>
                        <div class="el-form-item__error">
                            {{ filesError }}
                        </div>
                    </el-form-item>
                </template>
                <template v-else-if="field=='project_description'">
                    <div class="projectdesc">
                        <div class="field-heading">Project Description *</div>
                        <el-form-item :prop="field">
                            <InputWh :placeholder="field" fieldType="textarea" :required="rules[field][0].required"
                                     :formName="formName" :formStep="step" v-model="formData[field]"></InputWh>
                        </el-form-item>
                    </div>
                </template>
                <el-form-item v-else :prop="field">
                    <InputWh :placeholder="field" v-model="formData[field]" :disabled="field!='vat_id'?isSame:false"
                             :formName="formName" :formStep="step" :required="rules[field][0].required"></InputWh>
                </el-form-item>
            </el-col>
        </el-row>
        <div class="form-buttons">
            <el-button @click="$emit('prevStep')" type="text" size="medium" icon="el-icon-arrow-left" v-if="step>0">
                Back
            </el-button>
            <div v-else>&nbsp;</div>
            <el-button @click="handleNextStep()">Next</el-button>
        </div>
    </el-form>
</template>

<script>
import InputWh from '@/core/components/InputWithHint'

export default {
    props: {
        value: {
            type: Object, default: () => {
                return {}
            }
        },
        applicant: Object,
        stepTitle: String,
        step: Number
    },
    components: {
        InputWh
    },
    computed: {
        yearOptions: function () {
            let currentYear = (new Date()).getFullYear() - 10;
            let yearOptions = {};
            for (let year = currentYear; year <= currentYear + 10; year++) {
                yearOptions[year] = year;
            }
            return yearOptions;
        },
        isSame: function () {
            if (this.formData.sameAsApplicant) {
                return true;
            }
            return false;
        },
        formData: {
            get() {
                return this.value;
            },
            set(newVal) {

            }
        }
    },
    methods: {
        handleNextStep() {
            let self = this;
            this.$refs.stepForm.validate((valid) => {
                if (valid) {
                    if (self.formData.images && self.formData.images.length == 0) {
                        self.filesError = 'You should upload at least one file.';
                    } else {
                        self.$emit('nextStep');
                    }
                } else {
                    alert('Please correct the form errors before proceeding to the next step.');
                }
            });
        },
        handleRemove(file, fileList) {
            let newImages = [];
            fileList.forEach(function (listFile) {
                newImages.push(listFile);
            })
            this.formData.images = newImages;
        },
        handleChange(file, fileList) {
            let self = this;
            let currentFiles = [...self.formData.images];
            let sizeLimit = 6 * 1024 * 1024;
            let fileSize = file.raw.size;
            let fileType = file.raw.type;

            self.filesError = '';
            self.$refs.uploader[0].clearFiles();

            const reader = new FileReader();

            reader.onload = function (e) {


                let img = document.createElement("img");
                img.onload = function (event) {
                    if (self.formData.images.length > 5) {
                        self.filesError = 'You cannot upload more than 6 files.';
                    } else if (['image/jpeg', 'image/jpg', 'image/png'].indexOf(fileType) < 0) {
                        self.filesError = 'The image format should only be JPEG or PNG.';
                    } else if (fileSize > sizeLimit) {
                        self.filesError = 'The image is too big. It should be at most 6MB.';
                    }

                    if (self.filesError) {
                        self.formData.images = currentFiles;
                        return false;
                    }

                    // Dynamically create a canvas element
                    let canvas = document.createElement("canvas");

                    // var canvas = document.getElementById("canvas");
                    let ctx = canvas.getContext("2d");
                    ctx.canvas.width = 100;
                    ctx.canvas.height = 100;

                    // Actual resizing
                    ctx.drawImage(img, 0, 0, 100, 100);

                    // Show resized image in preview element
                    file.url = canvas.toDataURL(file.raw.type);

                    self.formData.images.push(file);
                }
                img.src = e.target.result;
            }

            reader.onerror = function (error) {
                self.filesError = 'Oops! That file could not be parsed, please try again.';
            }

            reader.readAsDataURL(file.raw);
        },
        copyApplicantDetails: function () {
            if (this.formData.sameAsApplicant !== undefined) {
                if (this.formData.sameAsApplicant == 1) {
                    let step1values = Object.assign({}, this.applicant);
                    Object.keys(step1values).forEach(key => {
                        if (this.formData[key] !== undefined) {
                            this.formData[key] = step1values[key];
                        }
                    });
                } else {
                    /*Object.keys(this.formData).forEach(key => {
                        this.formData[key] = '';
                    });*/
                }
            }
        }
    },
    watch: {
        'formData.country': function (newVal, oldVal) {
            let self = this;
            if (self.formData.state_region !== undefined) {
                if (newVal && self.stateOptions[newVal]) {
                    self.currentStateOptions = self.stateOptions[newVal];
                }
            }
        },
        step: function (newVal, oldVal) {
            this.copyApplicantDetails();
        },
        'formData.sameAsApplicant': function (newVal, oldVal) {
            this.copyApplicantDetails();
        }
    },
    data: () => ({
        rules: {
            firstname: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            lastname: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            company_name: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            job_title: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            phone_number: [
                {required: true, pattern: /^[0-9._\+\-\(\) ]+$/i, message: 'This field is invalid', trigger: 'blur'}
            ],
            fax: [
                {required: false, message: 'This field is required', trigger: 'blur'}
            ],
            email: [
                {required: true, message: 'This field is required', trigger: 'blur'},
                {type: 'email', message: 'This field is invalid', trigger: 'blur'}
            ],
            web_address: [
                {required: true, message: 'This is not a valid website', trigger: 'blur'}
            ],
            address1: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            address2: [
                {required: false, message: 'This field is required', trigger: 'blur'}
            ],
            country: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            state_region: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            city: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            postcode: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            applying_as: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            newsletter: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            category: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            subcategory: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            project_title: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            year_of_production: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            state_country_of_production: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            designer_name: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            manufacturer: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            photographer: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            other: [
                {required: false, message: 'This field is required', trigger: 'blur'}
            ],
            design_team: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            images: [
                {required: false}
            ],
            project_description: [
                {required: true, message: 'This field is required', trigger: 'blur'},
                {min: 0, max: 2500, message: 'This should be up to 2500 characters (~500 words)', trigger: 'blur'}
            ],
            vat_id: [
                {required: true, message: 'This field is required', trigger: 'blur'}
            ],
            sameAsApplicant: [
                {required: false, message: 'This field is required', trigger: 'blur'}
            ],
        },
        formName: 'furli',
        countryOptions: window._countries,
        stateOptions: window._states,
        currentStateOptions: [],
        categoryOptions: {
            'Lighting': 'Lighting',
            'Furniture': 'Furniture'
        },
        subCategoryOptions: {
            'Lighting': {
                'Table Lighting Units': 'Table Lighting Units',
                'Floor Lighting Units': 'Floor Lighting Units',
                'Ceiling Lighting Units': 'Ceiling Lighting Units',
                'Outdoor Lighting Units': 'Outdoor Lighting Units',
                'Wall Lighting Units': 'Wall Lighting Units',
            },
            'Furniture': {
                'Seating Units': 'Seating Units',
                'Chair Units': 'Chair Units',
                'Office Chair Units': 'Office Chair Units',
                'Office/Home Desk Units': 'Office/Home Desk Units',
                'Office Pod Units': 'Office Pod Units',
                'Storage Units': 'Storage Units',
                'Closets': 'Closets',
                'Table Units': 'Table Units',
                'Wall and Ceiling Partitions': 'Wall and Ceiling Partitions',
                'Built-in-Furniture': 'Built-in-Furniture',
                'Fabric/Textile Units': 'Fabric/Textile Units',
                'Floor and Wallcovering Units': 'Floor and Wallcovering Units',
                'Urban Furniture': 'Urban Furniture',
            }
        },
        filesError: ''
    }),
}
</script>
